import { render } from "./mindmapPage.vue?vue&type=template&id=5ce2848b&scoped=true"
import script from "./mindmapPage.vue?vue&type=script&lang=js"
export * from "./mindmapPage.vue?vue&type=script&lang=js"

import "./mindmapPage.vue?vue&type=style&index=0&id=5ce2848b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce2848b"]])

export default __exports__